import { pipe, catchError } from 'overmind';

import type { Context } from '@/overmind';
import { getRequestAborter } from '@/overmind/effects/requestAborter';
import { UnexpectedStateError, AbortError } from '@/overmind/errors';

const { switchToNewRequest, completeRequestOperator } =
  getRequestAborter('loadFeatureServer');

export const loadFeatureServer = pipe(
  async ({ state, effects }: Context) => {
    const abortController = switchToNewRequest();
    const adapter = effects.arcgisMapAdapter.getAdapter();
    if (adapter) {
      state.arcgis.featureServer.send('TRIGGER_LOADING');
      return adapter.getLayers(abortController);
    }

    throw new UnexpectedStateError();
  },
  ({ state }: Context, layers) => {
    state.arcgis.featureServer.send('FETCH_SUCCESS', layers);
  },
  catchError(({ state }: Context, error) => {
    if (
      !(error instanceof UnexpectedStateError || error instanceof AbortError)
    ) {
      state.arcgis.featureServer.send('FETCH_ERROR', error.message);
    }
  }),
  completeRequestOperator()
);

export const resetFeatureServerState = pipe(async ({ state }: Context) => {
  state.arcgis.featureServer.send('UNLOAD');
});
